import React,{useState,useEffect} from 'react'
import {Link, Redirect} from 'react-router-dom'
import './styles/submissions.css'
import {auth} from './firebase'


import Submission from './submission'

export default function Submissions() {
    const [loading,setLoading]=useState(false)
    const [problems,setProblems]=useState([])
    const [loggedIn, setLoggedIn]=useState(true)

    //===================================================================
    //
    //toggling the bar
    //
    //===================================================================
    const openDrawer=()=>{
        const drawer=document.querySelector('.drawer')
     
        drawer.classList.toggle('open-drawer')
        
        //console.log('done')
    }

    //=====================================================================
    //
    //  Checking if logged in
    //
    //=====================================================================
    const isLoggedIn=()=>{
        auth.onAuthStateChanged(user=>{
            if(user){
                setLoggedIn(true)
            }
            else{
                alert("Please login")
                setLoggedIn(false)
            }
        })
    }


    
    //====================================================================
    //
    //  Getting user data
    //
    //====================================================================
    //creating a list to put all the data in
    let listed=[]
    const getSubmissions=()=>{
        setLoading(true)
        let handleName=document.querySelector("#handleName").value
        let number=document.querySelector('#number').value
        let url=`https://codeforces.com/api/user.status?handle=${handleName}&from=1&count=${number}`
        fetch(url)
            .then((res)=>res.json())
            .then((data)=>{
                //console.log(data.result)
                
            data.result.forEach(a=>{
                if(a.verdict==='OK'){
                    listed.push(a)}
            })
            })
            .then(()=>{
                console.log(listed)
                setProblems(listed)
                setLoading(false)
                
            })
            .catch(()=>{
                alert('Please enter a correct handle')
                window.location.reload()
            })
    }

    useEffect(()=>isLoggedIn(),[])
    if (loading){
        return(
            <div className="loading-screen">
            <i class="material-icons loading"> hourglass_empty</i>
            <p>Loading......</p>
            </div>
        );
    }
    if(!loggedIn){
        return(<Redirect to='/'/>)
    }
    else{
        return (
        <div>
            <div className="navbar">
                <h3>Codeforces tracked</h3>
                <i class="material-icons md-64" onClick={openDrawer}>menu</i>
                <ul class='drawer'>
                    <Link to='/home' style={{textDecoration:'none', color:'black'}}><li>My Account</li></Link>
                    <Link to='/problems'style={{textDecoration:'none', color:'black'}}><li>Saved Problems</li></Link>
                    <Link to='/submissions' style={{textDecoration:'none', color:'black'}}><li>Submissions</li></Link>
                    <Link to='/friends' style={{textDecoration:'none', color:'black'}}><li>Track friends</li></Link>
                    <li>Upcoming</li>
                    <li onClick={()=>auth.signOut()}>Log Out</li>
                </ul>
            </div>
            <div className="title">
                <h1>View Submissions</h1>
                <p>Returns the accepted submissions among the total searched submissions</p>
            </div>
            

            
            <div className="inputs">
                <input type="text" id='handleName' placeholder='Target handle'/>
                <input type="number" id='number' placeholder='Number of submissions'/>
                <i class="material-icons" id='add' onClick={getSubmissions}>search</i>
            </div>

            <div className="main-container">
                {problems.map(a=>{
                    //console.log(a)
                    return(
                        <Submission key={a.id} data={a}/>
                    )
                })}
            </div>



        </div>
    )


    }

}
